import { useTranslation } from 'react-i18next';
import './logo-roller.css';

const LOGOS = [
  { name: 'Salesforce', src: '/logos/salesforce.svg', kind: 'icon' },
  { name: 'HubSpot', src: '/logos/hubspot.svg', kind: 'icon' },
  { name: 'Dynamics 365', src: '/logos/dynamics365.svg', kind: 'icon' },
  { name: 'Zoho', src: '/logos/zoho.svg', kind: 'icon' },
  { name: 'SAP', src: '/logos/sap.svg', kind: 'sap' },
  { name: 'Oracle', src: '/logos/oracle.svg', kind: 'oracle' },
  { name: 'NetSuite', src: '/logos/netsuite.svg', kind: 'icon' },
  { name: 'ServiceNow', src: '/logos/servicenow.svg', kind: 'icon' },
  { name: 'Microsoft', src: '/logos/microsoft.svg', kind: 'icon' },
  { name: 'Google Workspace', src: '/logos/google-workspace.svg', kind: 'icon' },
  { name: 'Slack', src: '/logos/slack.svg', kind: 'icon' },
  { name: 'Zendesk', src: '/logos/zendesk.svg', kind: 'icon' },
  { name: 'AWS', src: '/logos/aws.svg', kind: 'aws' },
] as const;

function AwsMark() {
  return (
    <span className="logo-aws" aria-hidden="true">
      <span>aws</span>
      <svg viewBox="0 0 48 12">
        <path
          d="M4 3.5c10 8 30 8.2 40-2"
          fill="none"
          stroke="#FF9900"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path d="M41 2.2l6 1.8-4 5" fill="#FF9900" />
      </svg>
    </span>
  );
}

function LogoMark({ src, kind }: { src: string; kind: string }) {
  if (kind === 'aws') return <AwsMark />;
  if (kind === 'sap') {
    return (
      <span className="logo-wordmark logo-sap" aria-hidden="true">
        SAP
      </span>
    );
  }
  if (kind === 'oracle') {
    return (
      <span className="logo-wordmark logo-oracle" aria-hidden="true">
        oracle
      </span>
    );
  }
  return <img src={src} alt="" aria-hidden="true" />;
}

function LogoTile({ name, src, kind }: { name: string; src: string; kind: string }) {
  return (
    <li className="logo-roller-item">
      <span className="logo-roller-disc">
        <LogoMark src={src} kind={kind} />
      </span>
      <span className="logo-roller-name">{name}</span>
    </li>
  );
}

/**
 * Infinite logo strip under the hero.
 * Mix of CRM, ERP, and workplace tools, each on a light grey disc.
 *
 * @since 0.1.0
 */
const LogoRoller = () => {
  const { t } = useTranslation();

  return (
    <section className="logo-roller" aria-label={t('trusted_by')}>
      <div className="logo-roller-inner">
        <p className="logo-roller-label">{t('trusted_by')}</p>
        <div className="logo-roller-rail">
          <div className="logo-roller-fade logo-roller-fade-left" aria-hidden="true" />
          <div className="logo-roller-fade logo-roller-fade-right" aria-hidden="true" />
          <div className="logo-roller-mask">
            <div className="logo-roller-track">
              <ul className="logo-roller-set">
                {LOGOS.map((logo) => (
                  <LogoTile key={`a-${logo.name}`} {...logo} />
                ))}
              </ul>
              <ul className="logo-roller-set" aria-hidden="true">
                {LOGOS.map((logo) => (
                  <LogoTile key={`b-${logo.name}`} {...logo} />
                ))}
              </ul>
            </div>
          </div>
        </div>
        <p className="logo-roller-more">
          {t('and_more')}
          <span aria-hidden="true"> →</span>
        </p>
      </div>
    </section>
  );
};

export default LogoRoller;
